import { Navigate, useLocation, useParams } from 'react-router-dom';

export default function LegacyUploadRedirect() {
  const { projectId, batchId } = useParams();
  const location = useLocation();

  const search = new URLSearchParams(location.search);
  if (batchId) search.set('batch', batchId);

  return (
    <Navigate
      replace
      to={{
        pathname: `/projects/${projectId}/datacenter`,
        search: search.toString(),
        hash: location.hash,
      }}
      state={location.state}
    />
  );
}
